import React, { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import styles from "./styles/user_management.module.scss";
import { FaUserEdit } from "react-icons/fa";
import { Col, Row, Spinner } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  useDeleteFaqsMutation,
  useGetFeedbackDetailsQuery,
  useGetUserFeedbackDetailsQuery,
  useGetUserFeedbackQuery,
} from "../../Data/services/faqApi.js";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
import { Button, SubTitle } from "../../Components/CustomComponents/index.js";
import CustomSpinner from "../../Components/CustomComponents/CustomSpinner.js";
import Table from "../../Components/Table/Table.js";
import { GrAction } from "react-icons/gr";
import UserFeedbackDtlModal from "../../Components/Modals/UserFeedbackDtlModal.jsx";

const UserFeedbackScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  // const data = [
  //   {
  //     question: "What is JavaScript?",
  //     answer:
  //       "JavaScript is a programming language used to create dynamic and interactive content on websites.",
  //     order: 1,
  //   },
  //   {
  //     question: "What is React?",
  //     answer:
  //       "React is a JavaScript library for building user interfaces, maintained by Facebook.",
  //     order: 2,
  //   },
  //   {
  //     question: "What is Node.js?",
  //     answer:
  //       "Node.js is a JavaScript runtime built on Chrome's V8 JavaScript engine, used for server-side programming.",
  //     order: 3,
  //   },
  //   {
  //     question: "What is Express.js?",
  //     answer:
  //       "Express.js is a web application framework for Node.js, designed for building web applications and APIs.",
  //     order: 4,
  //   },
  // ];

  const {
    data: resp,
    isSuccess,
    refetch,
  } = useGetUserFeedbackQuery({
    limit: pageSize,
    page: currentPage,
  });

  const {data} = useGetFeedbackDetailsQuery();

  useEffect(() => {
    setRowData(Array.isArray(resp?.data) ? resp.data : []);
  }, [resp]);

  useEffect(() => {
    if (resp) {
      // console.log(data);
      setPageSize(resp?.links?.per_page);
      setCurrentPage(resp?.links?.current);
      setTotalRecords(resp?.links?.total_records);
      setTotalPages(resp?.links?.total);
      setRowData(Array.isArray(resp?.data) ? resp.data : []);
      setDataFetched(true);
    }
  }, [resp]);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  const [deleteFaqs, { isLoading: isDeleting }] = useDeleteFaqsMutation();

  const deleteData = async (slug) => {
    try {
      const { data } = await deleteFaqs(slug);
      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "name",
      text: "Name",
      // sort: true,
      headerStyle: {
        width: "200px",
      },
      style: {
        whiteSpace: "normal",
        wordBreak: "break-word",
      },
    },
    {
      dataField: "email",
      text: "Email",
      // sort: true,
      headerStyle: {
        width: "250px",
      },
      style: {
        whiteSpace: "normal",
        wordBreak: "break-word",
      },
    },
    {
      dataField: "total_feedbacks",
      text: "Total Feedbacks",
      // sort: true,
      align: "center",
      headerStyle: {
        width: "140px",
      },
      style: {
        marginLeft: "10px",
      },
    },
    {
      dataField: "actions",
      text: "Feedback Details",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "200px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        // if (row.slug) {
        return (
          <div className="d-flex justify-content-center align-items-center ">
            <div
              className={`${styles.btnBg} d-flex justify-content-center align-items-center text-white bg-secondary rounded-3 mx-2 p-2 `}
              role="button"
              onClick={() => {
                setEditedData(row);
                handleEditModalOpen(true);
              }}
            >
              <span
                className={`align-items-center d-flex justify-content-center pe-1 `}
              >
                <GrAction />
              </span>
              <span>View</span>
            </div>
          </div>
        );
        // },
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}

      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <UserFeedbackDtlModal
            handleViewModalClose={handleEditModalClose}
            id={editedData.id}
            refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <SubTitle
            text={"User Feedback's Management"}
            classes="text-black"
          />
        </div>

      </div>

      <div className={styles.mainTable}>
        {!dataFetched || !isSuccess ? (
          <CustomSpinner />
        ) : (
          rowData?.length > 0 ?
          <Table
            data={rowData ?? []}
            columns={columns}
            indication={indication}
            totalRecords={totalRecords} // todo
            totalPages={totalPages} // todo
            pageSize={pageSize} // todo
            currentPage={currentPage} // todo
            setCurrentPage={setCurrentPage} // todo
            setPageSize={setPageSize} // todo
            refetch={refetch} // todo
          /> : <div className="w-100 d-flex justify-content-center vh-100">NO DATA AVAILABLE</div>
        )}
      </div>
    </div>
  );
};

export default UserFeedbackScreen;
